import { FormControl } from "@mui/base";
import debounce from "lodash.debounce";
import CloseIcon from "@mui/icons-material/Close";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { pink } from "@mui/material/colors";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { compose } from "@reduxjs/toolkit";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import { ButtonCompo } from "../../components/Comman/Button";
import { LabelCompo } from "../../components/Comman/Label";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { TextFieldCompo } from "../../components/Comman/TextFieldCompo";
import DynamicDetails from "../../components/dynamicscreens/DynamicDetails";
import { withRouter } from "../../components/withRouter";
import {
  checkboxShadowColor,
  redColor,
  titleColor,
} from "../../config/ColorObj";
import endpoint from "../../config/endpoints";
import {
  cdMsg,
  discountPercentageErrorMsg,
  saveFailedMsg,
  savemsg,
  saveWarningMsg,
} from "../../config/messageconstant";
import { apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { classes, children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

class BillingWithOffer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openDialog: false,
      dataList: [],
      checkboxAllData: [],
      offerBillNewData: {},
      billOfferId: "",
      outletHeader: "",
      stockChangedList: [],
      isShowBillDiscount: false,
      isShowItemWiseDiscount: false,
      discountInputValue: 0,
      formErrors: {},
      onChangeFlag: false,
    };
    this.debouncedCalculation = debounce(this.handleDiscountCalculation, 1000);
  }
  componentDidMount() {
    const { offerBillOutletData, flag } = this.props;

    let isShowBillDiscount = localStorage.getItem(
      "isShowDiscountAtPrimaryBilling"
    );

    let isShowItemWiseDiscount = localStorage.getItem(
      "isShowItemDiscountAtPrimaryBilling"
    );

    this.setState({
      isShowBillDiscount: isShowBillDiscount == 1 ? true : false,
      isShowItemWiseDiscount: isShowItemWiseDiscount == 1 ? true : false,
    });

    const stockCurrentList = localStorage.getItem("stockList");
    const valuesArray = JSON.parse(stockCurrentList);
    if (flag) {
      let i;
      let j;
      let stockDummyNewList = valuesArray;
      for (i = 0; i < stockDummyNewList.length; i++) {
        for (
          j = 0;
          j <
          offerBillOutletData.stockStakeHolderBillHeader
            .stockStakeHolderBillDetails.length;
          j++
        ) {
          if (
            stockDummyNewList[i].productId ==
            offerBillOutletData.stockStakeHolderBillHeader
              .stockStakeHolderBillDetails[j].product.id
          ) {
            stockDummyNewList[i].stock =
              stockDummyNewList[i].stock -
              offerBillOutletData.stockStakeHolderBillHeader
                .stockStakeHolderBillDetails[j].freeQty;
          }
        }
      }
      this.setState({ stockChangedList: stockDummyNewList });
    }

    let dataList = [];

    dataList.push(offerBillOutletData);

    this.setState({
      dataList,
      offerBillNewData: offerBillOutletData,
      outletHeader: offerBillOutletData.stockStakeHolderBillHeader,
    });
  }
  clickSubmitOfferHandler = () => {
    const {
      offerBillNewData,
      dataList,
      stockChangedList,
      outletHeader,
      onChangeFlag,
    } = this.state;
    const { salesPersonId, showLoador, showNotification } = this.props;

    let finaDataJson = {};
    const finalDataList = dataList.map((dataObj) => {
      const originalDetails =
        dataObj.stockStakeHolderBillHeader.stockStakeHolderBillDetails;
      const updatedDetails =
        dataObj.stockStakeHolderBillsAfterApplyingOffers
          .stockStakeHolderBillDetails;

      const mergedDetails = originalDetails.map((detail, index) => ({
        ...detail,
        itemDiscPer: updatedDetails[index]?.itemDiscPer,
      }));
      finaDataJson = {
        ...dataObj,
        stockStakeHolderBillHeader: {
          ...dataObj.stockStakeHolderBillHeader,
          discountOnbillPer: onChangeFlag
            ? dataObj.stockStakeHolderBillsAfterApplyingOffers.discountOnbillPer
            : 0,
          stockStakeHolderBillDetails: mergedDetails,
        },
        // productAndStocks: stockChangedList,
        productAndStocks:
          localStorage.getItem("isShowStocksEmptyForPrimaryBilling") &&
          localStorage.getItem("isShowStocksEmptyForPrimaryBilling") == 0
            ? stockChangedList
            : [],
      };
    });
    if (this.checkValidation()) {
      swal({
        title: "Are you sure?",
        text: saveWarningMsg,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          showLoador({ loador: true });
          apiPost({
            url:
              endpoint.stockStakeholderBillHeader +
              "/save-after-applying-offers-and-discount",
            postBody: finaDataJson,
          }).then(({ data, success }) => {
            showLoador({ loador: false });
            if (success) {
              showNotification({ msg: savemsg });

              window.location.replace("/received-order-list");
            } else {
              showNotification({ msg: saveFailedMsg, severity: "error" });
            }
          });
        }
      });
    }
  };

  clickSubmitHandler = () => {
    const { checkboxAllData, offerBillNewData, billOfferId, stockChangedList } =
      this.state;
    const { offerBillOutletData } = this.props;
    if (offerBillNewData.length !== 0) {
      let dataToSave = [];
      if (
        Object.keys(offerBillNewData.stockStakeHolderBillHeader).length !== 0 &&
        offerBillNewData.stockStakeHolderBillHeader.id == billOfferId
      ) {
        let billCheckedOfferData = [];
        if (offerBillNewData.offerHeaders.length !== 0) {
          offerBillNewData.offerHeaders.map((offerData) => {
            if (checkboxAllData.length !== 0) {
              checkboxAllData.map((checkedData) => {
                if (checkedData.id == offerData.id) {
                  billCheckedOfferData.push(checkedData);
                }
              });
            }
          });
        }
        let billObjectData = {
          stockStakeHolderBillHeader:
            offerBillNewData.stockStakeHolderBillHeader,
          offerHeaders: billCheckedOfferData,
          // productAndStocks: stockChangedList,
          productAndStocks:
            localStorage.getItem("isShowStocksEmptyForPrimaryBilling") &&
            localStorage.getItem("isShowStocksEmptyForPrimaryBilling") == 0
              ? stockChangedList
              : [],
        };
        dataToSave.push(billObjectData);
      }
      this.onSave(dataToSave[0]);
    }
  };

  onSave = (dataToSave) => {
    const { offerBillNewData, openDialog } = this.state;
    const { flag, showLoador } = this.props;
    const stockCurrentList = localStorage.getItem("stockList");
    const valuesArray = JSON.parse(stockCurrentList);
    showLoador({ loador: true });
    apiPost({
      url: endpoint.stockStakeholderBillHeader + "/apply-offer",
      postBody: dataToSave,
    }).then(({ data, success }) => {
      showLoador({ loador: false });
      if (success) {
        if (flag) {
          let i;
          let j;
          let stockDummyNewList = valuesArray;
          for (i = 0; i < stockDummyNewList.length; i++) {
            for (
              j = 0;
              j <
              data.data.stockStakeHolderBillHeader.stockStakeHolderBillDetails
                .length;
              j++
            ) {
              if (
                stockDummyNewList[i].productId ==
                data.data.stockStakeHolderBillHeader
                  .stockStakeHolderBillDetails[j].product.id
              ) {
                stockDummyNewList[i].stock =
                  stockDummyNewList[i].stock -
                  data.data.stockStakeHolderBillHeader
                    .stockStakeHolderBillDetails[j].freeQty;
              }
            }
          }
          this.setState({ stockChangedList: stockDummyNewList });
        }
        let newObjectToSave = {
          ...data.data.stockStakeHolderBillsAfterApplyingOffers,
          stockStakeHolderBillDetails:
            data.data.stockStakeHolderBillsAfterApplyingOffers.stockStakeHolderBillDetails.map(
              (stockStakeHolderBillObject) => {
                let productWithoutBillObject =
                  data.data.stockStakeHolderBillHeader.stockStakeHolderBillDetails.filter(
                    (row) => row.id == stockStakeHolderBillObject.id
                  );
                if (productWithoutBillObject.length !== 0) {
                  stockStakeHolderBillObject = {
                    ...stockStakeHolderBillObject,

                    taxableAmtWithoutOffer:
                      productWithoutBillObject[0].taxableAmt,
                    totalAmtWithoutOffer: productWithoutBillObject[0].totalAmt,
                  };
                  return stockStakeHolderBillObject;
                } else {
                  stockStakeHolderBillObject = {
                    ...stockStakeHolderBillObject,
                    taxableAmtWithoutOffer: 0.0,
                    totalAmtWithoutOffer: 0.0,
                  };
                  return stockStakeHolderBillObject;
                }
              }
            ),
        };
        let newData = {
          ...data.data,
          stockStakeHolderBillsAfterApplyingOffers: newObjectToSave,
        };

        let dataList = [];

        dataList.push(newData);

        this.setState({
          dataList,
          openDialog: !openDialog,
        });
      } else {
        showNotification({
          msg: saveFailedMsg,
          severity: "error",
        });
      }
    });
  };

  onCheckBoxClick = (checkedValue, headerId) => {
    const { checkboxAllData, offerBillNewData } = this.state;
    const { offerBillOutletData } = this.props;

    let checkboxData = [];
    if (offerBillNewData.length !== 0) {
      if (
        Object.keys(offerBillNewData.stockStakeHolderBillsAfterApplyingOffers)
          .length !== 0 &&
        offerBillNewData.stockStakeHolderBillsAfterApplyingOffers.id ===
          headerId
      ) {
        checkboxAllData.map((allOffer) => {
          if (
            allOffer.level == 0 &&
            allOffer.type == 0 &&
            checkedValue.level == 0 &&
            checkedValue.type == 0
          ) {
            if (allOffer.id == checkedValue.id) {
              let allOfferData = {
                ...allOffer,
                isApplied: allOffer.isApplied == 1 ? 0 : 1,
                appliedOfferId:
                  offerBillNewData.stockStakeHolderBillsAfterApplyingOffers.id,
              };
              checkboxData.push(allOfferData);
            } else {
              let allOfferData = {
                ...allOffer,
                isApplied: allOffer.isApplied == 1 ? 0 : 0,
              };
              checkboxData.push(allOfferData);
            }
          } else if (
            allOffer.level == 0 &&
            allOffer.type == 1 &&
            checkedValue.level == 0 &&
            checkedValue.type == 1
          ) {
            if (allOffer.id == checkedValue.id) {
              let allOfferData = {
                ...allOffer,
                isApplied: allOffer.isApplied == 1 ? 0 : 1,
                appliedOfferId:
                  offerBillNewData.stockStakeHolderBillsAfterApplyingOffers.id,
              };
              checkboxData.push(allOfferData);
            } else {
              let allOfferData = {
                ...allOffer,
                isApplied: allOffer.isApplied == 1 ? 0 : 0,
              };
              checkboxData.push(allOfferData);
            }
          } else if (
            allOffer.level == 1 &&
            allOffer.type == 0 &&
            checkedValue.level == 1 &&
            checkedValue.type == 0
          ) {
            if (allOffer.id == checkedValue.id) {
              let allOfferData = {
                ...allOffer,
                isApplied: allOffer.isApplied == 1 ? 0 : 1,
                appliedOfferId:
                  offerBillNewData.stockStakeHolderBillsAfterApplyingOffers.id,
              };
              checkboxData.push(allOfferData);
            } else {
              let allOfferData = {
                ...allOffer,
                isApplied: allOffer.isApplied,
              };
              checkboxData.push(allOfferData);
            }
          } else if (
            allOffer.level == 1 &&
            allOffer.type == 1 &&
            checkedValue.level == 1 &&
            checkedValue.type == 1
          ) {
            if (allOffer.id == checkedValue.id) {
              let allOfferData = {
                ...allOffer,
                isApplied: allOffer.isApplied == 1 ? 0 : 1,
                appliedOfferId:
                  offerBillNewData.stockStakeHolderBillsAfterApplyingOffers.id,
              };
              checkboxData.push(allOfferData);
            } else {
              let allOfferData = {
                ...allOffer,
                isApplied: allOffer.isApplied,
              };
              checkboxData.push(allOfferData);
            }
          } else {
            checkboxData.push(allOffer);
          }
        });
      }
    }
    this.setState({
      checkboxAllData: checkboxData,
    });
  };

  clickHandler = (billId) => {
    const { openDialog, dataList } = this.state;
    let checkboxData = [];
    this.setState({
      openDialog: !openDialog,
      checkboxAllData: [],
      billOfferId: billId,
    });
    if (dataList.length !== 0) {
      dataList.map((offerData) => {
        if (
          Object.keys(offerData.stockStakeHolderBillsAfterApplyingOffers)
            .length !== 0 &&
          offerData.stockStakeHolderBillsAfterApplyingOffers.id == billId &&
          offerData.offerHeaders.length !== 0
        ) {
          offerData.offerHeaders.map((allOffer) => {
            let allOfferData = {
              ...allOffer,
              appliedOfferId:
                offerData.stockStakeHolderBillsAfterApplyingOffers.id,
            };
            checkboxData.push(allOfferData);
          });
        }
      });
    }
    this.setState({
      checkboxAllData: checkboxData,
    });
  };

  checkValidation = () => {
    const { dataList, discountInputValue } = this.state;
    let formErrors = {};
    let formIsValid = true;

    // Validation for CD
    if (
      discountInputValue === "" ||
      discountInputValue === null ||
      discountInputValue === undefined
    ) {
      formIsValid = false;
      formErrors["distcountAmtError"] = cdMsg;
    } else if (discountInputValue > 100) {
      formIsValid = false;
      formErrors["distcountAmtError"] = discountPercentageErrorMsg;
    } else if (discountInputValue < 0) {
      formIsValid = false;
      formErrors["distcountAmtError"] =
        "Discount percentage cannot be negative.";
    }

    // Validation for item-wise discounts
    dataList.forEach((dataObj) => {
      const billDetails =
        dataObj?.stockStakeHolderBillsAfterApplyingOffers
          ?.stockStakeHolderBillDetails || [];
      billDetails.forEach((detailObj) => {
        const itemDisc = detailObj.itemDiscPer;
        const itemId = detailObj.id;
        const errorKey = `itemDiscPerError_${itemId}`;

        if (itemDisc === "" || itemDisc === null || itemDisc === undefined) {
          formIsValid = false;
          formErrors[errorKey] = "Item discount required";
        } else if (itemDisc > 100) {
          formIsValid = false;
          formErrors[errorKey] = discountPercentageErrorMsg;
        } else if (itemDisc < 0) {
          formIsValid = false;
          formErrors[errorKey] = "Item discount percentage cannot be negative.";
        }
      });
    });

    this.setState({ formErrors });
    return formIsValid;
  };

  handleInputChange = (dataKey, id) => (event) => {
    const { value } = event.target;
    console.log("Input value:", value);

    // Always clear the specific error
    this.setState((prevState) => ({
      formErrors: {
        ...prevState.formErrors,
        distcountAmtError: false,
      },
    }));

    // If empty, clear input + calculations and stop
    if (value === "" || value === undefined) {
      this.setState({ discountInputValue: "" });
      this.clearBillDiscounts();
      return;
    }

    // Improved regex: allows "3.", ".5", "3.5", "3"
    if (!/^\d*\.?\d*$/.test(value)) {
      return;
    }

    // Parse float
    const floatValue = parseFloat(value);

    // Handle if user typed just "." (parseFloat gives NaN)
    if (isNaN(floatValue)) {
      this.setState({ discountInputValue: value });
      return;
    }

    // Prevent out of bounds
    if (floatValue < 0 || floatValue > 100) {
      return;
    }

    // Valid
    this.setState({ discountInputValue: value });
    this.debouncedCalculation(dataKey, id, floatValue);
  };

  handleDiscountCalculation = (dataKey, id, value) => {
    const { dataList } = this.state;

    console.log("value-", value);

    const onChangeList = dataList.map((dataObj) => {
      const bill = dataObj.stockStakeHolderBillsAfterApplyingOffers;
      if (bill && Object.keys(bill).length !== 0 && id == bill.id) {
        const updatedDetails = bill.stockStakeHolderBillDetails.map(
          (detailsObj) => {
            const taxMultiplier =
              1 +
              ((detailsObj.sgstPer || 0) +
                (detailsObj.cgstPer || 0) +
                (detailsObj.igstPer || 0)) /
                100;
            const baseRate = detailsObj.rate / taxMultiplier;

            // Base amount before any discounts
            const baseTaxableAmt = baseRate * detailsObj.qty;

            // Offer discount
            const offerDiscountAmt = detailsObj.discountOnbillamt || 0;
            const afterOfferDiscountAmt = baseTaxableAmt - offerDiscountAmt;

            // Item-wise discount
            const itemDiscount =
              (afterOfferDiscountAmt * (detailsObj.itemDiscPer || 0)) / 100;
            const afterItemDiscountAmt = afterOfferDiscountAmt - itemDiscount;

            // Bill-wise discount
            const billDiscountAmt = (afterItemDiscountAmt * value) / 100;
            const finalTaxableAmt = afterItemDiscountAmt - billDiscountAmt;

            // Taxes
            const sgstAmt = (finalTaxableAmt * (detailsObj.sgstPer || 0)) / 100;
            const cgstAmt = (finalTaxableAmt * (detailsObj.cgstPer || 0)) / 100;
            const igstAmt = (finalTaxableAmt * (detailsObj.igstPer || 0)) / 100;

            // Total
            const totalAmt = finalTaxableAmt + sgstAmt + cgstAmt + igstAmt;

            return {
              ...detailsObj,
              cgstAmt,
              sgstAmt,
              igstAmt,
              itemDiscAmt: itemDiscount,
              discountOnbillamt: billDiscountAmt, // Bill-wise discount
              taxableAmt: finalTaxableAmt,
              totalAmt,
            };
          }
        );

        // Aggregate totals for the bill
        return {
          ...dataObj,
          stockStakeHolderBillsAfterApplyingOffers: {
            ...bill,
            [dataKey]: value, // Update the discount field
            taxableAmt: updatedDetails.reduce(
              (sum, row) => sum + row.taxableAmt,
              0
            ),
            totalAmt: updatedDetails.reduce(
              (sum, row) => sum + row.totalAmt,
              0
            ),
            cgstAmt: updatedDetails.reduce((sum, row) => sum + row.cgstAmt, 0),
            sgstAmt: updatedDetails.reduce((sum, row) => sum + row.sgstAmt, 0),
            igstAmt: updatedDetails.reduce((sum, row) => sum + row.igstAmt, 0),
            itemDiscountAmt: updatedDetails.reduce(
              (sum, row) => sum + row.itemDiscAmt,
              0
            ),
            discountOnbillAmt: updatedDetails.reduce(
              (sum, row) => sum + row.discountOnbillamt,
              0
            ),
            stockStakeHolderBillDetails: updatedDetails,
          },
        };
      }
      return dataObj;
    });

    this.setState({
      onChangeFlag: true,
      dataList: onChangeList,
    });
  };

  clearBillDiscounts = () => {
    const clearedList = this.state.dataList.map((dataObj) => {
      const bill = dataObj.stockStakeHolderBillsAfterApplyingOffers;
      if (bill && Object.keys(bill).length !== 0) {
        const updatedDetails = bill.stockStakeHolderBillDetails.map(
          (detailsObj) => ({
            ...detailsObj,
            discountOnbillamt: 0,
            taxableAmt: 0,
            totalAmt: 0,
            sgstAmt: 0,
            cgstAmt: 0,
            igstAmt: 0,
            itemDiscAmt: 0,
          })
        );

        return {
          ...dataObj,
          stockStakeHolderBillsAfterApplyingOffers: {
            ...bill,
            discountOnbillPer: 0,
            taxableAmt: 0,
            totalAmt: 0,
            sgstAmt: 0,
            cgstAmt: 0,
            igstAmt: 0,
            itemDiscountAmt: 0,
            discountOnbillAmt: 0,
            stockStakeHolderBillDetails: updatedDetails,
          },
        };
      }
      return dataObj;
    });

    this.setState({
      dataList: clearedList,
      discountInputValue: "",
    });
  };

  onChangeTextFieldItemDiscount = (dataKey, id) => (event) => {
    const { dataList, formErrors } = this.state;
    const { name, value } = event.target;

    this.setState({
      formErrors: {},
    });

    const onChangeList = dataList.map((dataObj) => {
      if (
        Object.keys(dataObj.stockStakeHolderBillsAfterApplyingOffers).length !==
          0 &&
        dataObj.stockStakeHolderBillsAfterApplyingOffers
          .stockStakeHolderBillDetails.length !== 0
      ) {
        const updatedDetails =
          dataObj.stockStakeHolderBillsAfterApplyingOffers.stockStakeHolderBillDetails.map(
            (detailsObj) => {
              if (id === detailsObj.id && value <= 100) {
                let newRate =
                  (detailsObj.rate * 100) /
                  (100 +
                    detailsObj.sgstPer +
                    detailsObj.cgstPer +
                    detailsObj.igstPer);

                let newTaxableAmt = newRate * detailsObj.qty;

                let offerDiscountAmt = detailsObj.discountOnbillamt;

                let newTaxableOfferAmt = newTaxableAmt - offerDiscountAmt;

                let newItemWiseDiscount = (newTaxableOfferAmt / 100) * value;

                let newTaxableWithItemWiseDiscount =
                  newTaxableOfferAmt - newItemWiseDiscount;

                let newBillWiseDiscount =
                  (newTaxableWithItemWiseDiscount / 100) *
                  dataObj.stockStakeHolderBillsAfterApplyingOffers
                    .discountOnbillPer;

                let newTaxableWithBillWiseDiscount =
                  newTaxableWithItemWiseDiscount - newBillWiseDiscount;

                let newSgstAmt =
                  (newTaxableWithBillWiseDiscount / 100) * detailsObj.sgstPer;

                let newCgstAmt =
                  (newTaxableWithBillWiseDiscount / 100) * detailsObj.cgstPer;

                let newIgstAmt =
                  (newTaxableWithBillWiseDiscount / 100) * detailsObj.igstPer;

                return {
                  ...detailsObj,
                  cgstAmt: newSgstAmt,
                  sgstAmt: newCgstAmt,
                  igstAmt: newIgstAmt,
                  itemDiscAmt: newItemWiseDiscount,
                  taxableAmt: newTaxableWithBillWiseDiscount,
                  totalAmt:
                    newTaxableWithBillWiseDiscount +
                    newSgstAmt +
                    newCgstAmt +
                    newIgstAmt,
                  [name]: value,
                };
              }
              return detailsObj;
            }
          );

        return {
          ...dataObj,
          stockStakeHolderBillsAfterApplyingOffers: {
            ...dataObj.stockStakeHolderBillsAfterApplyingOffers,
            taxableAmt: updatedDetails.reduce(
              (sum, row) => sum + row.taxableAmt,
              0
            ),
            totalAmt: updatedDetails.reduce(
              (sum, row) => sum + row.totalAmt,
              0
            ),
            cgstAmt: updatedDetails.reduce((sum, row) => sum + row.cgstAmt, 0),
            sgstAmt: updatedDetails.reduce((sum, row) => sum + row.sgstAmt, 0),
            igstAmt: updatedDetails.reduce((sum, row) => sum + row.igstAmt, 0),
            itemDiscountAmt: updatedDetails.reduce(
              (sum, row) => sum + row.itemDiscAmt,
              0
            ),
            stockStakeHolderBillDetails: updatedDetails,
          },
        };
      }
      return dataObj;
    });

    this.setState({
      dataList: onChangeList,
    });
  };

  render() {
    const {
      openDialog,
      checkboxAllData,
      formErrors,
      dataList,
      isShowBillDiscount,
      isShowItemWiseDiscount,
    } = this.state;
    const { onCancel } = this.props;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 2,
          }}
          elevation={0}
        >
          <LandingScreenHeader
            screenTitle={"Billing Preview"}
            showTable={false}
            showBackButton={true}
            showAddButton={false}
            onCancel={onCancel}
          />
          <br />
          {dataList.length !== 0 &&
            dataList.map((dataObj, index) => {
              let dataToShow = [];
              {
                isShowBillDiscount == 1 && isShowItemWiseDiscount == 1
                  ? (dataToShow = [
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Stock Holder No.",
                        value: 1,
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Stock Holder Name",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                            null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .toBillStakeHolder !== null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .toBillStakeHolder.ownerName
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Firm Name",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                            null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .toBillStakeHolder !== null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .toBillStakeHolder.firmName
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "State Name",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                            null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .toBillStakeHolder !== null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .toBillStakeHolder.state !== null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .toBillStakeHolder.state.name
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Bill No",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                          null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .billNo
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Bill Date",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                          null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .billDate
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Taxable Amount",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                          null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers.taxableAmt.toFixed(
                                2
                              )
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Total Tax",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers &&
                          Object.keys(
                            dataObj.stockStakeHolderBillsAfterApplyingOffers
                          ).length !== 0 &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .sgstAmt !== null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .cgstAmt !== null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .igstAmt !== null
                            ? (
                                dataObj.stockStakeHolderBillsAfterApplyingOffers
                                  .sgstAmt +
                                dataObj.stockStakeHolderBillsAfterApplyingOffers
                                  .cgstAmt +
                                dataObj.stockStakeHolderBillsAfterApplyingOffers
                                  .igstAmt
                              ).toFixed(2)
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Bill Discount Amt",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers &&
                          Object.keys(
                            dataObj.stockStakeHolderBillsAfterApplyingOffers
                          ).length !== 0 &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .discountOnbillAmt !== null
                            ? (+dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .discountOnbillAmt).toFixed(2)
                            : 0,
                      },

                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Item Discount Amt",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers &&
                          Object.keys(
                            dataObj.stockStakeHolderBillsAfterApplyingOffers
                          ).length !== 0 &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .itemDiscountAmt !== null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers.itemDiscountAmt.toFixed(
                                2
                              )
                            : "",
                      },

                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Total Amount",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                          null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers.totalAmt.toFixed(
                                2
                              )
                            : "",
                      },
                    ])
                  : isShowBillDiscount == 1
                  ? (dataToShow = [
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Stock Holder No.",
                        value: 1,
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Stock Holder Name",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                            null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .toBillStakeHolder !== null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .toBillStakeHolder.ownerName
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Firm Name",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                            null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .toBillStakeHolder !== null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .toBillStakeHolder.firmName
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "State Name",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                            null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .toBillStakeHolder !== null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .toBillStakeHolder.state !== null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .toBillStakeHolder.state.name
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Bill No",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                          null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .billNo
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Bill Date",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                          null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .billDate
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Taxable Amount",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                          null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers.taxableAmt.toFixed(
                                2
                              )
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Total Tax",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers &&
                          Object.keys(
                            dataObj.stockStakeHolderBillsAfterApplyingOffers
                          ).length !== 0 &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .sgstAmt !== null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .cgstAmt !== null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .igstAmt !== null
                            ? (
                                dataObj.stockStakeHolderBillsAfterApplyingOffers
                                  .sgstAmt +
                                dataObj.stockStakeHolderBillsAfterApplyingOffers
                                  .cgstAmt +
                                dataObj.stockStakeHolderBillsAfterApplyingOffers
                                  .igstAmt
                              ).toFixed(2)
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Bill Discount Amt",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers &&
                          Object.keys(
                            dataObj.stockStakeHolderBillsAfterApplyingOffers
                          ).length !== 0 &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .discountOnbillAmt !== null
                            ? (+dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .discountOnbillAmt).toFixed(2)
                            : 0,
                      },

                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Total Amount",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                          null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers.totalAmt.toFixed(
                                2
                              )
                            : "",
                      },
                    ])
                  : isShowItemWiseDiscount == 1
                  ? (dataToShow = [
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Stock Holder No.",
                        value: 1,
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Stock Holder Name",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                            null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .toBillStakeHolder !== null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .toBillStakeHolder.ownerName
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Firm Name",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                            null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .toBillStakeHolder !== null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .toBillStakeHolder.firmName
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "State Name",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                            null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .toBillStakeHolder !== null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .toBillStakeHolder.state !== null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .toBillStakeHolder.state.name
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Bill No",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                          null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .billNo
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Bill Date",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                          null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .billDate
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Taxable Amount",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                          null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers.taxableAmt.toFixed(
                                2
                              )
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Total Tax",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers &&
                          Object.keys(
                            dataObj.stockStakeHolderBillsAfterApplyingOffers
                          ).length !== 0 &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .sgstAmt !== null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .cgstAmt !== null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .igstAmt !== null
                            ? (
                                dataObj.stockStakeHolderBillsAfterApplyingOffers
                                  .sgstAmt +
                                dataObj.stockStakeHolderBillsAfterApplyingOffers
                                  .cgstAmt +
                                dataObj.stockStakeHolderBillsAfterApplyingOffers
                                  .igstAmt
                              ).toFixed(2)
                            : "",
                      },

                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Item Discount Amt",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers &&
                          Object.keys(
                            dataObj.stockStakeHolderBillsAfterApplyingOffers
                          ).length !== 0 &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .itemDiscountAmt !== null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers.itemDiscountAmt.toFixed(
                                2
                              )
                            : "",
                      },

                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Total Amount",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                          null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers.totalAmt.toFixed(
                                2
                              )
                            : "",
                      },
                    ])
                  : isShowBillDiscount == 0 && isShowItemWiseDiscount == 0
                  ? (dataToShow = [
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Stock Holder No.",
                        value: 1,
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Stock Holder Name",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                            null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .toBillStakeHolder !== null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .toBillStakeHolder.ownerName
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Firm Name",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                            null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .toBillStakeHolder !== null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .toBillStakeHolder.firmName
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "State Name",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                            null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .toBillStakeHolder !== null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .toBillStakeHolder.state !== null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .toBillStakeHolder.state.name
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Bill No",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                          null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .billNo
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Bill Date",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                          null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers
                                .billDate
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Taxable Amount",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                          null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers.taxableAmt.toFixed(
                                2
                              )
                            : "",
                      },
                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Total Tax",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers &&
                          Object.keys(
                            dataObj.stockStakeHolderBillsAfterApplyingOffers
                          ).length !== 0 &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .sgstAmt !== null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .cgstAmt !== null &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .igstAmt !== null
                            ? (
                                dataObj.stockStakeHolderBillsAfterApplyingOffers
                                  .sgstAmt +
                                dataObj.stockStakeHolderBillsAfterApplyingOffers
                                  .cgstAmt +
                                dataObj.stockStakeHolderBillsAfterApplyingOffers
                                  .igstAmt
                              ).toFixed(2)
                            : "",
                      },

                      {
                        xs: 12,
                        sm: 6,
                        md: 6,
                        lg: 6,
                        labelXS: 12,
                        labelSM: 4,
                        labelMD: 4,
                        labelLG: 4,
                        valueXS: 12,
                        valueSM: 8,
                        valueMD: 8,
                        valueLG: 8,
                        label: "Total Amount",
                        value:
                          dataObj.stockStakeHolderBillsAfterApplyingOffers !==
                          null
                            ? dataObj.stockStakeHolderBillsAfterApplyingOffers.totalAmt.toFixed(
                                2
                              )
                            : "",
                      },
                    ])
                  : [];
              }
              return (
                <>
                  <DynamicDetails DataToSet={dataToShow} />

                  {dataObj !== null &&
                    Object.keys(dataObj).length !== 0 &&
                    dataObj.offerHeaders.length !== 0 && (
                      <>
                        <Grid
                          item
                          sm={12}
                          xs={12}
                          md={12}
                          lg={12}
                          container
                          justifyContent="flex-end"
                        >
                          <ButtonCompo
                            sx={{
                              bgcolor: "dodgerblue", // theme.palette.primary.main
                              color: "#fbff00",
                              opacity: "0.9",
                              transform: "scale(0.9)",
                              ":hover": {
                                display: "inline-block",
                                bgcolor: "#fbff00", // theme.palette.primary.main
                                color: "dodgerblue",
                                opacity: "0.9",
                                transform: "scale(1.5)",
                                transitionDuration: "3s",
                                backfaceVisibility: "hidden",
                                transform:
                                  "translate(2px, 2px) rotate(0deg)  scale(2)",
                                config: {
                                  tension: "300",
                                  friction: "10",
                                },
                              },
                            }}
                            size="medium"
                            type="button"
                            variant="contained"
                            name={"Offer"}
                            onClick={(e) =>
                              this.clickHandler(
                                dataObj.stockStakeHolderBillsAfterApplyingOffers
                                  .id
                              )
                            }
                            fullWidth={false}
                          />
                        </Grid>
                      </>
                    )}
                  {Object.keys(dataObj).length !== 0 && (
                    <>
                      <TableContainer>
                        <Table stickyHeader aria-label="sticky table">
                          <TableHead>
                            <TableRow>
                              <TableCell align="center" sx={{ width: "3%" }}>
                                Sr. No
                              </TableCell>
                              <TableCell align="center" sx={{ width: "13%" }}>
                                Product Name
                              </TableCell>
                              <TableCell align="center" sx={{ width: "5%" }}>
                                Quantity
                              </TableCell>
                              <TableCell align="center" sx={{ width: "7%" }}>
                                Free Quantity
                              </TableCell>
                              {isShowItemWiseDiscount && (
                                <>
                                  <TableCell
                                    align="center"
                                    sx={{ width: "7%" }}
                                  >
                                    Discount (%)
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    sx={{ width: "7%" }}
                                  >
                                    Discount Amount
                                  </TableCell>
                                </>
                              )}
                              <TableCell align="center" sx={{ width: "10%" }}>
                                Taxable Amount
                              </TableCell>
                              <TableCell align="center" sx={{ width: "10%" }}>
                                Total Amount
                              </TableCell>
                              <TableCell align="center" sx={{ width: "13%" }}>
                                Taxable Amount with offer
                              </TableCell>
                              <TableCell align="center" sx={{ width: "13%" }}>
                                Total Amount with offer
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          {Object.keys(
                            dataObj.stockStakeHolderBillsAfterApplyingOffers
                          ).length !== 0 &&
                            dataObj.stockStakeHolderBillsAfterApplyingOffers
                              .stockStakeHolderBillDetails.length !== 0 &&
                            dataObj.stockStakeHolderBillsAfterApplyingOffers.stockStakeHolderBillDetails.map(
                              (billDetails, index) => {
                                return (
                                  <>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        sx={{ width: "5%" }}
                                      >
                                        {index + 1}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        sx={{ width: "13%" }}
                                      >
                                        {billDetails !== null &&
                                        billDetails.product !== null
                                          ? billDetails.product.name
                                          : ""}
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        sx={{ width: "13%" }}
                                      >
                                        {billDetails !== null
                                          ? billDetails.qty.toFixed(2)
                                          : ""}
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        sx={{ width: "13%" }}
                                      >
                                        {billDetails !== null
                                          ? billDetails.freeQty.toFixed(2)
                                          : ""}
                                      </TableCell>
                                      {isShowItemWiseDiscount && (
                                        <>
                                          <TableCell
                                            align="right"
                                            sx={{ width: "10%" }}
                                          >
                                            <TextFieldCompo
                                              placeHolder={"Discount %"}
                                              size="small"
                                              color="primary"
                                              name="itemDiscPer"
                                              id={"1"}
                                              value={billDetails.itemDiscPer}
                                              onChange={this.onChangeTextFieldItemDiscount(
                                                "itemDiscPer",
                                                billDetails.id
                                              )}
                                              fullWidth={false}
                                              disabled={
                                                billDetails.freeQty > 0
                                                  ? true
                                                  : false
                                              }
                                              errorText={
                                                formErrors[
                                                  `itemDiscPerError_${billDetails.id}`
                                                ] || ""
                                              }
                                            />
                                          </TableCell>
                                          <TableCell
                                            align="right"
                                            sx={{ width: "10%" }}
                                          >
                                            {billDetails.itemDiscAmt.toFixed(2)}
                                          </TableCell>
                                        </>
                                      )}
                                      <TableCell
                                        align="right"
                                        sx={{ width: "13%" }}
                                      >
                                        {billDetails !== null
                                          ? billDetails.taxableAmtWithoutOffer.toFixed(
                                              2
                                            )
                                          : ""}
                                      </TableCell>
                                      <TableCell
                                        align="right"
                                        sx={{ width: "13%" }}
                                      >
                                        {billDetails !== null
                                          ? billDetails.totalAmtWithoutOffer.toFixed(
                                              2
                                            )
                                          : ""}
                                      </TableCell>
                                      <TableCell
                                        align="right"
                                        sx={{ width: "15%" }}
                                      >
                                        {billDetails !== null
                                          ? billDetails.taxableAmt.toFixed(2)
                                          : ""}
                                      </TableCell>
                                      <TableCell
                                        align="right"
                                        sx={{ width: "15%" }}
                                      >
                                        {billDetails !== null
                                          ? billDetails.totalAmt.toFixed(2)
                                          : ""}
                                      </TableCell>
                                    </TableRow>
                                  </>
                                );
                              }
                            )}
                        </Table>
                        {Object.keys(dataObj).length !== 0 &&
                          Object.keys(
                            dataObj.stockStakeHolderBillsAfterApplyingOffers
                          ).length !== 0 &&
                          dataObj.stockStakeHolderBillsAfterApplyingOffers
                            .appliedOffers.length !== 0 && (
                            <>
                              <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell
                                      align="center"
                                      sx={{ width: "5.5%" }}
                                    >
                                      Sr. No
                                    </TableCell>
                                    <TableCell
                                      align="center"
                                      sx={{ width: "80%" }}
                                    >
                                      Offer Name
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                {dataObj
                                  .stockStakeHolderBillsAfterApplyingOffers
                                  .appliedOffers.length !== 0 &&
                                  dataObj.stockStakeHolderBillsAfterApplyingOffers.appliedOffers.map(
                                    (offerAppliedData, index) => {
                                      return (
                                        <>
                                          <TableRow>
                                            <TableCell align="center">
                                              {index + 1}
                                            </TableCell>
                                            <TableCell
                                              align="left"
                                              sx={{ width: "80%" }}
                                            >
                                              {offerAppliedData !== null
                                                ? offerAppliedData.name
                                                : ""}
                                            </TableCell>
                                          </TableRow>
                                        </>
                                      );
                                    }
                                  )}
                              </Table>
                            </>
                          )}
                      </TableContainer>
                      <br />

                      {isShowBillDiscount && (
                        <Grid
                          item
                          sm={6}
                          xs={12}
                          md={6}
                          lg={6}
                          container
                          justifyContent="space-between"
                        >
                          <Grid
                            item
                            sm={6}
                            xs={8}
                            md={6}
                            lg={6}
                            container
                            justifyContent="space-between"
                          >
                            <Grid item xs={12} md={5} sm={5}>
                              <LabelCompo
                                className="text-black"
                                style={{ fontSize: 16, color: titleColor }}
                                label="CD (%) :"
                              />
                            </Grid>
                            <Grid item xs={12} md={7} sm={7}>
                              <TextFieldCompo
                                placeHolder={"Enter CD"}
                                size="small"
                                color="primary"
                                name="discountOnbillPer"
                                id={"1"}
                                value={this.state.discountInputValue}
                                onChange={this.handleInputChange(
                                  "discountOnbillPer",
                                  dataObj
                                    .stockStakeHolderBillsAfterApplyingOffers.id
                                )}
                                fullWidth={false}
                                errorText={
                                  this.state.formErrors["distcountAmtError"]
                                    ? this.state.formErrors["distcountAmtError"]
                                    : ""
                                }
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                    </>
                  )}
                  <br />
                  {openDialog && (
                    <>
                      <BootstrapDialog
                        onClose={this.clickHandler}
                        aria-labelledby="customized-dialog-title"
                        open={true}
                        fullWidth
                        maxWidth="500px"
                      >
                        <BootstrapDialogTitle
                          id="customized-dialog-title"
                          onClose={this.clickHandler}
                        >
                          Applicable Offers
                          <Grid
                            item
                            sm={12}
                            xs={12}
                            md={12}
                            lg={12}
                            container
                            justifyContent="flex-between"
                          >
                            <Grid
                              item
                              sm={6}
                              xs={6}
                              md={6}
                              lg={6}
                              container
                              justifyContent="flex-start"
                            >
                              {checkboxAllData.length !== 0 &&
                                checkboxAllData.map((applicableOfferData) => {
                                  if (
                                    applicableOfferData.type == 0 &&
                                    applicableOfferData.level == 0
                                  ) {
                                    return (
                                      <>
                                        <Typography
                                          sx={{ p: 0, marginLeft: 2 }}
                                          variant="h6"
                                          color="textSecondary"
                                        >
                                          <FormControl component="fieldset">
                                            <FormGroup
                                              aria-label="position"
                                              row
                                            >
                                              <FormControlLabel
                                                value="end"
                                                control={
                                                  <Checkbox
                                                    sx={{
                                                      color:
                                                        checkboxShadowColor,
                                                      "& .MuiSvgIcon-root": {
                                                        fontSize: 30,
                                                      },
                                                      "&.Mui-checked": {
                                                        color: pink[600],
                                                      },
                                                    }}
                                                    color="secondary"
                                                  />
                                                }
                                                sx={{
                                                  ".css-19g4vwf-MuiTypography-root":
                                                    {
                                                      fontSize: "1.3rem",
                                                      color: "#000000",
                                                    },
                                                }}
                                                label={applicableOfferData.name}
                                                onChange={(e) => {
                                                  this.onCheckBoxClick(
                                                    applicableOfferData,
                                                    applicableOfferData.appliedOfferId
                                                  );
                                                }}
                                                labelPlacement="end"
                                                checked={
                                                  applicableOfferData.isApplied ==
                                                  1
                                                    ? true
                                                    : false
                                                }
                                              />
                                            </FormGroup>{" "}
                                            {applicableOfferData.isApplied !==
                                            2 ? (
                                              <div
                                                style={{
                                                  marginLeft: "40px",
                                                  fontSize: "1.1rem",
                                                }}
                                              >
                                                {
                                                  applicableOfferData.discription
                                                }
                                              </div>
                                            ) : (
                                              <FormHelperText
                                                style={{
                                                  marginLeft: "40px",
                                                }}
                                                error
                                              >
                                                {
                                                  "Due to a shortage of stock, the offer is not applicable"
                                                }
                                              </FormHelperText>
                                            )}
                                          </FormControl>
                                        </Typography>
                                      </>
                                    );
                                  }
                                })}
                            </Grid>

                            <Grid
                              item
                              sm={6}
                              xs={6}
                              md={6}
                              lg={6}
                              container
                              justifyContent="flex-start"
                            >
                              {checkboxAllData.length !== 0 &&
                                checkboxAllData.map((applicableOfferData) => {
                                  if (
                                    applicableOfferData.type == 1 &&
                                    applicableOfferData.level == 0
                                  ) {
                                    return (
                                      <>
                                        <Typography
                                          sx={{ p: 0, marginLeft: 2 }}
                                          variant="h6"
                                          color="textSecondary"
                                        >
                                          <FormControl component="fieldset">
                                            <FormGroup
                                              aria-label="position"
                                              row
                                            >
                                              <FormControlLabel
                                                value="end"
                                                control={
                                                  <Checkbox
                                                    sx={{
                                                      color:
                                                        checkboxShadowColor,
                                                      "& .MuiSvgIcon-root": {
                                                        fontSize: 30,
                                                      },
                                                      "&.Mui-checked": {
                                                        color: pink[600],
                                                      },
                                                    }}
                                                    color="secondary"
                                                  />
                                                }
                                                sx={{
                                                  ".css-19g4vwf-MuiTypography-root":
                                                    {
                                                      fontSize: "1.3rem",
                                                      color: "#000000",
                                                    },
                                                }}
                                                label={applicableOfferData.name}
                                                onChange={(e) => {
                                                  this.onCheckBoxClick(
                                                    applicableOfferData,
                                                    applicableOfferData.appliedOfferId
                                                  );
                                                }}
                                                labelPlacement="end"
                                                checked={
                                                  applicableOfferData.isApplied ==
                                                  1
                                                    ? true
                                                    : false
                                                }
                                              />
                                              {applicableOfferData.isApplied !==
                                              2 ? (
                                                <div
                                                  style={{
                                                    marginLeft: "40px",
                                                    fontSize: "1.1rem",
                                                  }}
                                                >
                                                  {
                                                    applicableOfferData.discription
                                                  }
                                                </div>
                                              ) : (
                                                <FormHelperText
                                                  style={{
                                                    marginLeft: "40px",
                                                  }}
                                                  error
                                                >
                                                  {
                                                    "Due to a shortage of stock, the offer is not applicable"
                                                  }
                                                </FormHelperText>
                                              )}
                                            </FormGroup>
                                          </FormControl>
                                        </Typography>
                                      </>
                                    );
                                  }
                                })}
                            </Grid>
                          </Grid>
                          <br />
                          <Grid
                            item
                            sm={12}
                            xs={12}
                            md={12}
                            lg={12}
                            container
                            justifyContent="flex-between"
                          >
                            <Grid
                              item
                              sm={6}
                              xs={6}
                              md={6}
                              lg={6}
                              container
                              justifyContent="flex-start"
                            >
                              {checkboxAllData.length !== 0 &&
                                checkboxAllData.map((applicableOfferData) => {
                                  if (
                                    applicableOfferData.type == 0 &&
                                    applicableOfferData.level == 1
                                  ) {
                                    return (
                                      <>
                                        <Typography
                                          sx={{ p: 0, marginLeft: 2 }}
                                          variant="h6"
                                          color="textSecondary"
                                        >
                                          <FormControl component="fieldset">
                                            <FormGroup
                                              aria-label="position"
                                              row
                                            >
                                              <FormControlLabel
                                                value="end"
                                                control={
                                                  <Checkbox
                                                    sx={{
                                                      color:
                                                        checkboxShadowColor,
                                                      "& .MuiSvgIcon-root": {
                                                        fontSize: 30,
                                                      },
                                                      "&.Mui-checked": {
                                                        color: pink[600],
                                                      },
                                                    }}
                                                    color="secondary"
                                                  />
                                                }
                                                sx={{
                                                  ".css-19g4vwf-MuiTypography-root":
                                                    {
                                                      fontSize: "1.3rem",
                                                      color: "#000000",
                                                    },
                                                }}
                                                label={applicableOfferData.name}
                                                onChange={(e) => {
                                                  this.onCheckBoxClick(
                                                    applicableOfferData,
                                                    applicableOfferData.appliedOfferId
                                                  );
                                                }}
                                                labelPlacement="end"
                                                checked={
                                                  applicableOfferData.isApplied ==
                                                  1
                                                    ? true
                                                    : false
                                                }
                                              />
                                            </FormGroup>{" "}
                                            {applicableOfferData.isApplied !==
                                            2 ? (
                                              <div
                                                style={{
                                                  marginLeft: "40px",
                                                  fontSize: "1.1rem",
                                                }}
                                              >
                                                {
                                                  applicableOfferData.discription
                                                }
                                              </div>
                                            ) : (
                                              <FormHelperText
                                                style={{
                                                  marginLeft: "40px",
                                                }}
                                                error
                                              >
                                                {
                                                  "Due to a shortage of stock, the offer is not applicable"
                                                }
                                              </FormHelperText>
                                            )}
                                          </FormControl>
                                        </Typography>
                                      </>
                                    );
                                  }
                                })}
                            </Grid>

                            <Grid
                              item
                              sm={6}
                              xs={6}
                              md={6}
                              lg={6}
                              container
                              justifyContent="flex-start"
                            >
                              {checkboxAllData.length !== 0 &&
                                checkboxAllData.map((applicableOfferData) => {
                                  if (
                                    applicableOfferData.type == 1 &&
                                    applicableOfferData.level == 1
                                  ) {
                                    return (
                                      <>
                                        <Typography
                                          sx={{ p: 0, marginLeft: 2 }}
                                          variant="h6"
                                          color="textSecondary"
                                        >
                                          <FormControl component="fieldset">
                                            <FormGroup
                                              aria-label="position"
                                              row
                                            >
                                              <FormControlLabel
                                                value="end"
                                                control={
                                                  <Checkbox
                                                    sx={{
                                                      color:
                                                        checkboxShadowColor,
                                                      "& .MuiSvgIcon-root": {
                                                        fontSize: 30,
                                                      },
                                                      "&.Mui-checked": {
                                                        color: pink[600],
                                                      },
                                                    }}
                                                    color="secondary"
                                                  />
                                                }
                                                sx={{
                                                  ".css-19g4vwf-MuiTypography-root":
                                                    {
                                                      fontSize: "1.5rem",
                                                      color: "#000000",
                                                    },
                                                }}
                                                label={applicableOfferData.name}
                                                onChange={(e) => {
                                                  this.onCheckBoxClick(
                                                    applicableOfferData,
                                                    applicableOfferData.appliedOfferId
                                                  );
                                                }}
                                                labelPlacement="end"
                                                checked={
                                                  applicableOfferData.isApplied ==
                                                  1
                                                    ? true
                                                    : false
                                                }
                                              />
                                              {applicableOfferData.isApplied !==
                                              2 ? (
                                                <div
                                                  style={{
                                                    marginLeft: "40px",
                                                    fontSize: "1.1rem",
                                                  }}
                                                >
                                                  {
                                                    applicableOfferData.discription
                                                  }
                                                </div>
                                              ) : (
                                                <FormHelperText
                                                  style={{
                                                    marginLeft: "40px",
                                                  }}
                                                  error
                                                >
                                                  {
                                                    "Due to a shortage of stock, the offer is not applicable"
                                                  }
                                                </FormHelperText>
                                              )}
                                            </FormGroup>
                                          </FormControl>
                                        </Typography>
                                      </>
                                    );
                                  }
                                })}
                            </Grid>
                          </Grid>
                          <br />
                          <Grid
                            item
                            sm={12}
                            xs={12}
                            md={12}
                            lg={12}
                            container
                            justifyContent="flex-end"
                          >
                            <ButtonCompo
                              sx={{
                                bgcolor: "dodgerblue",
                                color: "#fbff00",
                              }}
                              size="medium"
                              type="button"
                              variant="contained"
                              name={"Submit"}
                              onClick={this.clickSubmitHandler}
                              fullWidth={false}
                            />
                          </Grid>
                        </BootstrapDialogTitle>
                      </BootstrapDialog>
                    </>
                  )}
                </>
              );
            })}
          <br />
          <Grid
            item
            sm={12}
            xs={12}
            md={12}
            lg={12}
            container
            justifyContent="flex-end"
          >
            <ButtonCompo
              sx={{
                bgcolor: "dodgerblue",
                color: "#fbff00",
              }}
              size="medium"
              type="button"
              variant="contained"
              name={"Save Bill"}
              onClick={this.clickSubmitOfferHandler}
              fullWidth={false}
            />
          </Grid>
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  showLoador,
  showNotification,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(BillingWithOffer);
